export default {
	required: v => !!v || 'Tämä tieto on pakollinen.',
	email: v => /.+@.+/.test(v) || 'Tarkista sähköpostiosoitteen muotoilu.',
	min_5_characters: v => ((v || '').length >= 5) || 'Tarkista syötteen pituus.',
	max_30_characters: v => ((v || '').length <= 30) || 'Tarkista syötteen pituus.',
}
